<!-- Invalid BEM naming convention -->
<div class="tnc__basic__container">
    <p [innerHTML]="termsContent() | safe:'html'"></p>
</div>
